import { AdminProfileDto } from './admin-profile.dto';
import { LocationDto } from '../common/location.dto';

export interface AdminProfileDetailDto extends AdminProfileDto {
  permissions: string[];
  hiredDate?: string | null; // DateTime as ISO string
  workLocation?: LocationDto | null;
  managerName?: string | null;
  totalNotificationsSent: number;
  totalActionsPerformed: number;
}
